//CONEXION BACKEND DESARROLLO - /login
// export const baseUrlDavid = 'http://192.168.10.8/historial-clinico-backend/public/api';
// export const urlImagen = 'http://192.168.10.8/historial-clinico-backend/public/';

export const baseUrlDavid = 'http://192.168.4.230/historial-clinico-backend/public/api';
export const urlImagen = 'http://192.168.4.230/historial-clinico-backend/public/';
//http://192.168.4.230 deploy server
//http://23.254.165.3 testing
//http://23.254.228.60 ip produccion

// export const baseUrlDavid = 'http://23.254.228.60/historial-clinico-backend/public/api';
// export const urlImagen = 'http://23.254.228.60/historial-clinico-backend/public/';

// export const baseUrl = 'http://127.0.0.1:8000/api'; // DEVELOP
export const baseUrl = 'http://192.236.179.158/cbv-back-report/public/api'; // PRODUCCION
export const baseUrlImage = 'http://127.0.0.1:8000';
export const baseUrlNew = 'http://192.236.179.158/backend/public/api';
// export const apiReportUrl = 'http://localhost:8085/buenaventura-reportes'; // DEVELOP
export const apiReportUrl = 'http://198.12.255.151:8085/buenaventura-reportes'; // PRODUCCION
// http://localhost:8000
// http://192.236.179.158/backend/public
// http://192.168.4.230/historial-clinico-backend/public
export const baseUrlReports = 'http://127.0.0.1:8000/api'; // MODIFICAR EN PRODUCCION
export const baseUrlReportsNew = 'http://192.236.179.158/reportes/public/api';

//CONEXION BACKEND PRODUCCION
